/* eslint-disable no-restricted-properties */
import type { AuthMethodsType, User } from 'types/generic-context';
import type { localStorageTypesKeys } from '.';

export class LocalStorageService {
  get token(): string {
    return localStorage.token;
  }

  set token(token: string) {
    localStorage.token = token;
  }

  get firstName(): string {
    return localStorage.firstName;
  }

  set firstName(firstName: string) {
    localStorage.firstName = firstName;
  }

  get accountTypes(): string[] {
    return localStorage.accountTypes || [];
  }

  set accountTypes(accountTypes: string[]) {
    localStorage.accountTypes = accountTypes;
  }

  get activeAccountTypes(): string[] {
    return localStorage.activeAccountTypes || [];
  }

  set activeAccountTypes(activeAccountTypes: string[]) {
    localStorage.activeAccountTypes = activeAccountTypes;
  }

  get redirectUrl(): string {
    return localStorage.redirectUrl;
  }

  set redirectUrl(redirectUrl: string) {
    localStorage.redirectUrl = redirectUrl;
  }

  get user(): any | User {
    if (localStorage.user) {
      return JSON.parse(localStorage.user);
    }
    return {};
  }

  set user(user: User) {
    const stateUser = {
      ...user,
      userId: Number(user.userId) || 0,
      activeAccountTypes: user.activeAccountTypes,
      accountTypes:
        typeof user.accountTypes === 'string' ? decodeURIComponent(user.accountTypes).split(',') : user.accountTypes,
    };
    localStorage.user = JSON.stringify(stateUser);
  }

  get authTypes(): AuthMethodsType[] {
    if (localStorage.authTypes) {
      return JSON.parse(localStorage.authTypes);
    }
    return [];
  }

  set authTypes(authTypes: AuthMethodsType[]) {
    localStorage.authTypes = JSON.stringify(authTypes);
  }

  get debugLog(): boolean {
    return localStorage.debugLog;
  }

  set debugLog(debugLog: boolean) {
    localStorage.debugLog = debugLog;
  }

  get processedLiterals(): string[] {
    const literals = localStorage.getItem('processedLiterals');
    return literals ? JSON.parse(literals) : [];
  }

  set processedLiterals(literals: string[]) {
    localStorage.processedLiterals = JSON.stringify(literals);
  }

  get disableTracing(): boolean {
    return localStorage.disableTracing === 'true';
  }

  deleteItem(key: localStorageTypesKeys) {
    localStorage.removeItem(key);
  }

  getItem(key: localStorageTypesKeys) {
    return localStorage.getItem(key);
  }

  setItem(key: localStorageTypesKeys, value: string) {
    localStorage.setItem(key, value);
  }
}
